import { api } from "../../api";

export const KEY_ACCEPT = "accept";
export const KEY_REJECT = "reject";

type LatLngStrings = { latitude?: string | null; longitude?: string | null };

export type SpBookingListArgs = {
    type: "Ongoing" | "Booking";
    startDate?: string;
    endDate?: string;
    status?: string;
    page?: number;
    disabilities?: string;
    booking_id?: string;
};

export const spBookingsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSpHomeScreen: build.query<any, LatLngStrings>({
            query: ({ latitude, longitude }) => ({
                url: "/v1/service-provider/home-screen",
                params: {
                    ...(latitude != null && latitude !== ""
                        ? { latitude: String(latitude) }
                        : {}),
                    ...(longitude != null && longitude !== ""
                        ? { longitude: String(longitude) }
                        : {}),
                },
            }),
            providesTags: ["SpHome"],
        }),
        spRequestAcceptReject: build.mutation<
            any,
            { status: typeof KEY_ACCEPT | typeof KEY_REJECT; appointment_id: string }
        >({
            query: (body) => ({
                url: "/v1/service-provider/request-accept-reject",
                method: "POST",
                body,
            }),
            invalidatesTags: [
                "SpHome",
                "SpAppointmentDetails",
                { type: "SpBookingLists", id: "LIST" },
            ],
        }),
        getSpAppointmentDetails: build.query<
            any,
            { id: string | number } & LatLngStrings
        >({
            query: ({ id, latitude, longitude }) => ({
                url: `/v1/service-provider/appointment-details/${id}`,
                params: {
                    ...(latitude != null && latitude !== ""
                        ? { latitude: String(latitude) }
                        : {}),
                    ...(longitude != null && longitude !== ""
                        ? { longitude: String(longitude) }
                        : {}),
                },
            }),
            providesTags: ["SpAppointmentDetails"],
        }),
        getSpBookingLists: build.query<any, SpBookingListArgs>({
            query: ({
                type,
                startDate,
                endDate,
                status,
                page,
                disabilities,
                booking_id,
            }) => ({
                url: "/v1/service-provider/booking-lists",
                params: {
                    type,
                    startDate: startDate || undefined,
                    endDate: endDate || undefined,
                    status: status || undefined,
                    page: page ?? 1,
                    disabilities: disabilities || undefined,
                    booking_id: booking_id || undefined,
                },
            }),
            providesTags: () => [{ type: "SpBookingLists", id: "LIST" }],
        }),
        putSpBookingStatus: build.mutation<
            any,
            {
                id: string | number;
                booking_status: string;
                message?: string;
                otp?: string;
            }
        >({
            query: ({ id, booking_status, message, otp }) => ({
                url: `/v1/service-provider/booking-status/${id}`,
                method: "PUT",
                body: {
                    booking_status,
                    message: message ?? "",
                    otp: otp ?? "",
                },
            }),
            invalidatesTags: [
                "SpHome",
                "SpAppointmentDetails",
                { type: "SpBookingLists", id: "LIST" },
            ],
        }),
        getSpDisabilities: build.query<any, void>({
            query: () => "/v1/service-provider/disabilities",
        }),
        spBookingUpdateRequest: build.mutation<
            any,
            { status: string; appointment_id: string }
        >({
            query: (body) => ({
                url: "/v1/service-provider/booking-update-request",
                method: "POST",
                body,
            }),
            invalidatesTags: [
                "SpAppointmentDetails",
                "SpNotifications",
                { type: "SpBookingLists", id: "LIST" },
            ],
        }),
        postCallMaskingGetNumber: build.mutation<any, Record<string, unknown>>({
            query: (body) => ({
                url: "/v1/call-masking/get-number",
                method: "POST",
                body,
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetSpHomeScreenQuery,
    useSpRequestAcceptRejectMutation,
    useGetSpAppointmentDetailsQuery,
    useLazyGetSpAppointmentDetailsQuery,
    useGetSpBookingListsQuery,
    usePutSpBookingStatusMutation,
    useGetSpDisabilitiesQuery,
    useSpBookingUpdateRequestMutation,
    usePostCallMaskingGetNumberMutation,
} = spBookingsApi;
